import React, { useState, useEffect, useCallback } from 'react';
import { Card, Container, Row, Button, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Image } from "react-bootstrap";
import abcLogo from '../../../assets/images/books.jpeg';
import book from '../../../assets/images/books.jpeg';
import softCopy from '../../../assets/images/softCopy.jpg';
import Abbu from '../../../assets/images/Abbu.jpg';
import Mummy from '../../../assets/images/Mummy.png';
import cardCss from './About.css';
import Modal from '../Modal/Modal';
import Aux from '../../../hoc/Aux/Aux';
import { useHistory } from 'react-router-dom';


const alicard = (props) => {
const [clicked, setClicked] = useState(false);


const purchaseCancelHandler = () => {
  setClicked(false);
};


const history = useHistory();

const routeChange=(path)=> {
  //let path = `/PdfTable`;
  history.push(path);
  }
const orderSummary = ""

return (
  <Aux>
  <Modal show={clicked} modalClosed={purchaseCancelHandler}>
      {orderSummary}
  </Modal>


  <div className='panel panel-default align-items-center p-3 my-3' style={{'width':'100%', 'paddingTop':'0px', height:'100%', 'overflow':'scroll'}}>
            <div className='align-items-center p-3 my-3 rounded shadow panel-heading' style={{'boxShadow':'0 4px 8px 0 #042a4a', 'transition': '0.3s',"backgroundColor":"#042a4a",'color':"#3d4bb8","textAlign":"left", 'width':'98%', "align":"left"}}>
                    <span style={{fontWeight:'bold', fontSize:'1.0em', textAlign:"left", color:"white", backgroundColor:"#042a4a"}}>This humble work is dedicated to the Imam of our time - Imam Mehdi (atfs)</span>
            </div>
             <div className='align-items-center p-3 my-3 rounded shadow panel-body' style={{height:'100%','valign':'top','overflow': 'scroll','width':'98%'}}> 


             <br></br><span style={{fontWeight:'bold', fontSize:'1.2em'}}>In the memory of my beloved father and mother </span><br></br><br></br>


  <Container style={{paddingBottom:'20px'}}>
<Row style={{padding:'0px 0px 0px 0px'}}>
  <Col sm={6}>
  <Card className={cardCss.aliCard}>
    <Card.Img variant="top" as={Image} src={Abbu}    className={cardCss.aliImg}/>
    <Card.Body>
      <Card.Title style={{backgroundColor:"#042a4a", fontSize:"20px", color:"white"}}>
        
        
        <Button color="primary" className="px-4" style={{width:"100%", backgroundColor:"#042a4a", padding:"10px 5px 10px 5px", fontSize:"12px", color:"white", border: "none"}}
                onClick={(event) => {routeChange("/pdfTable")}}
                  >
                  Syed Ali Hussain Naqvi
                  s/o Syed Kamil Hussain Naqvi
      </Button>

        </Card.Title>
    </Card.Body>
  </Card>
  <br></br><br></br>
  </Col>

  <Col sm={6}>
  <Card className={cardCss.aliCard}>
  <Card.Img variant="top" as={Image} src={Mummy}  className={cardCss.aliImg}/>
    <Card.Body>
    <Card.Title style={{backgroundColor:"#042a4a", fontSize:"20px", color:"white"}}>
      
    <Button color="primary" className="px-4" style={{width:"100%", backgroundColor:"#042a4a", padding:"10px 5px 10px 5px", fontSize:"12px", color:"white", border: "none"}}
                onClick={(event) => {routeChange("/BlogList")}}
                >
                  Syeda Tahera Fatima
                  d/o Syed Akbar Mehdi Abidi
      </Button>
      
    </Card.Title>
    </Card.Body>
  </Card>
</Col>
  </Row>



</Container>
<div>
  Please recite a Sura e Fatiha for <span style={{fontWeight:'bold'}}> "Syed Ali Hussain Naqvi s/o Syed Kamil Hussain Naqvi"</span> and <span style={{fontWeight:'bold'}}>"Syeda Tahera Fatima d/o Syed Akbar Mehdi Abidi"</span>.
  <br></br><br></br>
</div>
</div>
</div>
</Aux>

);

};

export default alicard;


// WEBPACK FOOTER //
// ./src/components/UI/About/About.js